(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-feature-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.tl-grid__demo-video').forEach((video) => {
    // Respect reduced motion: stop the demo and let people play it themselves.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      video.removeAttribute('autoplay');
      video.pause();
      video.controls = true;
      return;
    }
    // Hold on the finished review for a moment instead of snapping straight back to the start.
    video.loop = false;
    video.addEventListener('ended', () => {
      setTimeout(() => {
        video.currentTime = 0;
        video.play().catch(() => {});
      }, 2500);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-spotlight"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tl-sticky-buy')) {
    customElements.define(
      'tl-sticky-buy',
      class extends HTMLElement {
        connectedCallback() {
          const watched = [
            document.querySelector('.tl-hero, .tl-banner'),
            document.getElementById(this.dataset.target),
            document.querySelector('.shopify-section-group-footer-group, footer'),
          ].filter(Boolean);
          if (!('IntersectionObserver' in window) || !watched.length) return;

          this.onScreen = new Set();
          this.observer = new IntersectionObserver((entries) => {
            for (const entry of entries) {
              if (entry.isIntersecting) this.onScreen.add(entry.target);
              else this.onScreen.delete(entry.target);
            }
            this.toggle(this.onScreen.size === 0);
          });
          watched.forEach((el) => this.observer.observe(el));
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }

        toggle(show) {
          this.classList.toggle('is-visible', show);
          this.inert = !show;
          if (show) this.removeAttribute('aria-hidden');
          else this.setAttribute('aria-hidden', 'true');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
